import * as React from 'react';
import styles from './index.less';
import { Dispatch } from 'redux';
import {
  ChangeAction,
  ResourceCreatorBatchPageState,
} from '@/models/resourceCreatorBatchPage';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import { RcFile } from 'antd/lib/upload/interface';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import { history } from 'umi';
import FPrompt from '@/components/FPrompt';
import { Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import FPopover from '@/components/FPopover';
import {
  getFilesSha1Info,
  handleData_By_Sha1_And_ResourceTypeCode_And_InheritData2,
} from '@/utils/service';
import fMessage from '@/components/fMessage';
import fObjectsSelectorDrawer from '@/components/fObjectsSelectorDrawer';
import UploadFile from './NoDate';
import Card from './Card';
import ErrorCard from './ErrorCard';
import Task from './Task';
import fReadLocalFiles from '@/components/fReadLocalFiles';
import * as AHooks from 'ahooks';
import FHotspotTooltip, {
  fSetHotspotTooltipVisible,
} from '@/components/FHotspotTooltip';
import { FRegExpMgr } from '@/utils/FRegExpMgr';
import FIcons from '@/components/FIcons';
import FGlobalLoading from '@/components/FGlobalLoading';

interface HandleProps {
  dispatch: Dispatch;
  resourceCreatorBatchPage: ResourceCreatorBatchPageState;
}

interface HandleStates {
  dataSource: {
    uid: string;
    state: 'localUpload' | 'list' | 'error';
    localUploadInfo: {
      uid: string;
      file: RcFile;
    } | null;
    listInfo: {
      uid: string;
      fileName: string;
      sha1: string;
      cover: string;
      resourceName: string;
      resourceName_optimized: string;
      resourceNameError: string;
      resourceTitle: string;
      resourceTitleError: string;
      resourceLabels: string[];
      resourcePolicies: {
        title: string;
        text: string;
      }[];
      showMore: boolean;
      systemProperties: {
        key: string;
        name: string;
        value: string;
        description: string;
        type: 'raw' | 'additional';
        valueConfig?: {
          text?: {
            nullable: boolean;
            minLength: number;
            maxLength: number;
          };
          textArea?: {
            nullable: boolean;
            minLength: number;
            maxLength: number;
          };
          integer?: {
            nullable: boolean;
            min: number;
            max: number;
          };
          decimal?: {
            nullable: boolean;
            minDecimal: number;
            maxDecimal: number;
            precision: number;
          };
          date?: {
            nullable: boolean;
            startDate: string;
            limitDate: string;
          };
          dataTime?: {
            nullable: boolean;
            startDateTime: string;
            limitDateTime: string;
          };
          configText?: {
            nullable: boolean;
            defaultValue: string;
            minLength: number;
            maxLength: number;
          };
          configEnum?: {
            nullable: boolean;
            defaultValue: string;
            options: string[];
          };
        };
      }[];
      customProperties: {
        key: string;
        name: string;
        value: string;
        description: string;
      }[];
      customConfigurations: {
        key: string;
        name: string;
        description: string;
        type: 'input' | 'select';
        input: string;
        select: string[];
      }[];
      directDependencies: {
        id: string;
        name: string;
        type: 'resource' | 'object';
        versionRange?: string;
      }[];
      baseUpcastResources: {
        resourceID: string;
        resourceName: string;
      }[];
      resolveResources: {
        resourceId: string;
        contracts: {
          policyId: string;
        }[];
      }[];
      isCompleteAuthorization: boolean;
      batchSignContracts: {
        resourceID: string;
        resourceName: string;
        policyIDs: string[];
        // subjectType: 'resource' | '';
        subjectType: string;
      }[];
    } | null;
    errorInfo: {
      uid: string;
      name: string;
      sha1: string;
      // reason: string;
      from: string;
      errorText: string;
      selfUsedResourcesAndVersions?: {
        resourceID: string;
        resourceName: string;
        resourceType: string[];
        resourceVersion: string;
        url: string;
      }[];
      otherUsedResourcesAndVersions?: {
        resourceID: string;
        resourceName: string;
        resourceType: string[];
        resourceVersion: string;
        url: string;
      }[];
    } | null;
  }[];
  tempLocalSuccess: {
    uid: string;
    name: string;
    sha1: string;
  }[];
}

const initStates: HandleStates = {
  dataSource: [],
  tempLocalSuccess: [],
};

function Handle({ dispatch, resourceCreatorBatchPage }: HandleProps) {
  const refPromise = React.useRef<Promise<void> | null>(null);

  const [$username, set$username, get$username] =
    FUtil.Hook.useGetState<string>('');
  const [$dataSource, set$dataSource, get$dataSource] = FUtil.Hook.useGetState<
    HandleStates['dataSource']
  >(initStates['dataSource']);
  const [$tempLocalSuccess, set$tempLocalSuccess, get$tempLocalSuccess] =
    FUtil.Hook.useGetState<HandleStates['tempLocalSuccess']>(
      initStates['tempLocalSuccess'],
    );
  const [$committing, set$committing, get$committing] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$submitDisable, set$submitDisable, get$submitDisable] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$globalLoading, set$globalLoading, get$globalLoading] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    const {
      data,
    }: {
      data: {
        username: string;
      };
    } = await FServiceAPI.User.currentUserInfo();
    // console.log(data, 'asd9ifjs;dlkfjlskdjflksdjlkjl');
    set$username(data.username);
  });

  AHooks.useDebounceEffect(
    () => {
      const disabled: boolean =
        $dataSource.filter((ds) => {
          return ds.state === 'list' && ds.listInfo;
        }).length === 0 ||
        $dataSource.some((ds) => {
          return ds.state !== 'list' || !ds.listInfo;
        }) ||
        $dataSource.some((r) => {
          return (
            r.state === 'list' &&
            r.listInfo &&
            (r.listInfo.resourceNameError !== '' ||
              r.listInfo.resourceTitleError !== '' ||
              !r.listInfo.isCompleteAuthorization)
          );
        }) ||
        $committing;
      set$submitDisable(disabled);

      if (!disabled) {
        fSetHotspotTooltipVisible(
          'batchResourceCreator.perfectInformation.submitButton',
          {
            value: true,
            effectiveImmediately: true,
            onlyNullish: true,
          },
        );
      }
    },
    [$dataSource, $committing],
    {
      wait: 100,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      if (
        get$tempLocalSuccess().length > 0 &&
        get$dataSource().filter((d) => {
          return d.state === 'localUpload' && d.localUploadInfo;
        }).length === get$tempLocalSuccess().length
      ) {
        handleLocalUploadSuccess();
      }
    },
    [$dataSource, $tempLocalSuccess],
    {
      wait: 300,
    },
  );

  const { run } = AHooks.useDebounceFn(
    () => {
      verifyDuplicationResourceName();
    },
    {
      wait: 200,
    },
  );

  function verifyDuplicationResourceName() {
    const map: Map<string, number> = new Map<string, number>();
    for (const resource of get$dataSource()) {
      if (resource.state === 'list' && resource.listInfo) {
        map.set(
          resource.listInfo.resourceName,
          (map.get(resource.listInfo.resourceName) || 0) + 1,
        );
      }
    }

    const dataSource: HandleStates['dataSource'] = get$dataSource().map(
      (info) => {
        if (info.state === 'list' && info.listInfo) {
          return {
            ...info,
            listInfo: {
              ...info.listInfo,
              resourceNameError:
                info.listInfo.resourceNameError !== '' &&
                info.listInfo.resourceNameError !== '不能重复'
                  ? info.listInfo.resourceNameError
                  : (map.get(info.listInfo.resourceName) || 0) > 1
                  ? '不能重复'
                  : '',
            },
          };
        }
        return info;
      },
    );
    set$dataSource(dataSource);
  }

  async function handleLocalUploadSuccess() {
    const promises: ReturnType<
      typeof handleData_By_Sha1_And_ResourceTypeCode_And_InheritData2
    >[] = get$tempLocalSuccess().map((f) => {
      return handleData_By_Sha1_And_ResourceTypeCode_And_InheritData2({
        sha1: f.sha1,
        resourceTypeCode:
          resourceCreatorBatchPage.selectedResourceType?.value || '',
        inheritData: {
          additionalProperties: [],
          customProperties: [],
          customConfigurations: [],
        },
      });
    });

    const result = await Promise.all(promises);
    let covers: string[] = [];
    if (
      resourceCreatorBatchPage.selectedResourceType?.labels.includes('图片')
    ) {
      covers = await handleImage({
        sha1s: get$tempLocalSuccess().map((o) => {
          return o.sha1;
        }),
      });
    }

    let dataSource = get$dataSource();
    const newDataSource: HandleStates['dataSource'] =
      get$tempLocalSuccess().map((f, f_index) => {
        const resourceName: string = getARightName(
          FRegExpMgr.removeExtension(f.name),
        ).substring(0, 50);
        const resourceTitle: string = f.name
          .replace(new RegExp(/\.[\w-]+$/), '')
          .substring(0, 100);
        const successFile = result.find((file) => {
          return f.sha1 === file.sha1;
        });
        // console.log(resourceName, 'resourceName isdojflkjsdlkfjlk');
        return {
          uid: f.uid,
          state: 'list',
          listInfo: {
            uid: f.uid,
            fileName: f.name,
            sha1: f.sha1,
            cover: covers[f_index] || '',
            resourceName: resourceName,
            resourceName_optimized: resourceName,
            resourceNameError: resourceName === '' ? '请输入资源授权标识' : '',
            resourceTitle: resourceTitle,
            resourceTitleError: '',
            resourceLabels: [],
            resourcePolicies: [],
            showMore: false,
            systemProperties: successFile?.systemProperties || [],
            customProperties: successFile?.customProperties || [],
            customConfigurations: successFile?.customConfigurations || [],
            directDependencies: [],
            baseUpcastResources: [],
            resolveResources: [],
            isCompleteAuthorization: true,
            batchSignContracts: [],
          },
          localUploadInfo: null,
          errorInfo: null,
        };
      });
    // console.info(JSON.parse(JSON.stringify(newDataSource)), 'newDataSource sdf9iajs;ldkfjlksadjflkjsdlkflsd');

    dataSource = dataSource.map((d) => {
      const data = newDataSource.find((nds) => {
        return nds.uid === d.uid;
      });
      if (!data) {
        return d;
      }
      return data;
    });

    const {
      data: data_ResourceNames,
    }: {
      data: {
        newResourceName: string;
      }[];
    } = await FServiceAPI.Resource.generateResourceNames({
      resourceNames: dataSource
        .filter((resource) => {
          return !(
            resource.state !== 'list' ||
            !resource.listInfo ||
            resource.listInfo.resourceName === ''
          );
        })
        .map((resource) => {
          return resource.listInfo?.resourceName || '';
        }),
    });

    const newResourceNames: string[] = data_ResourceNames.map((rn) => {
      return rn.newResourceName;
    });
    // console.log(JSON.stringify(newResourceNames), 'newResourceNamessldkfjlskdjl');
    set$dataSource(
      dataSource.map((resource) => {
        if (
          resource.state !== 'list' ||
          !resource.listInfo ||
          resource.listInfo.resourceName === ''
        ) {
          return resource;
        }
        const resourceName: string = newResourceNames.shift() || '';
        return {
          ...resource,
          listInfo: {
            ...resource.listInfo,
            resourceName,
            resourceName_optimized: resourceName,
          },
        };
      }),
    );
    set$tempLocalSuccess([]);
  }

  async function onLocalUpload() {
    const {
      data: data_acceptResourceType,
    }: {
      data: {
        formats: string[];
      };
    } = await FServiceAPI.Resource.getResourceTypeInfoByCode({
      code: resourceCreatorBatchPage.selectedResourceType?.value || '',
    });
    if (!data_acceptResourceType) {
      return;
    }

    // set$accept();
    const files: RcFile[] | null = await fReadLocalFiles({
      accept: data_acceptResourceType.formats.join(','),
      multiple: true,
    });

    if (!files) {
      return;
    }

    const localDataSource: HandleStates['dataSource'] = files.map((f) => {
      return {
        uid: f.uid,
        state: 'localUpload',
        localUploadInfo: {
          uid: f.uid,
          file: f,
        },
        listInfo: null,
        errorInfo: null,
      };
    });

    let dataSource: HandleStates['dataSource'] = [
      ...get$dataSource(),
      ...localDataSource,
    ];
    if (dataSource.length > 20) {
      // fMessage('上传不能超过20个文件', 'warning');
      fMessage(
        FI18n.i18nNext.t('brr_submitresource_alert_limitation'),
        'warning',
      );
      dataSource = dataSource.slice(0, 20);
    }
    set$dataSource(dataSource);
  }

  async function onImportStorage() {
    // console.log('********************** w98e4ifhruojkdsldkjlklkj');
    const objIDs: string[] | null = await fObjectsSelectorDrawer({
      resourceTypeCode:
        resourceCreatorBatchPage.selectedResourceType?.value || '',
    });
    // console.log(objIDs, 'objIDs');
    // console.log('######################## w98e4ifhruojkdsldkjlklkj');
    if (!objIDs) {
      return;
    }

    set$globalLoading(true);
    const {
      data: data_objs,
    }: {
      data: {
        customProperty: any;
        customPropertyDescriptors: any[];
        dependencies: [];
        objectId: string;
        objectName: string;
        sha1: string;
      }[];
    } = await FServiceAPI.Storage.batchObjectList({
      objectIds: objIDs.join(','),
    });

    const promises: ReturnType<
      typeof handleData_By_Sha1_And_ResourceTypeCode_And_InheritData2
    >[] = data_objs.map((f) => {
      return handleData_By_Sha1_And_ResourceTypeCode_And_InheritData2({
        sha1: f.sha1,
        resourceTypeCode:
          resourceCreatorBatchPage.selectedResourceType?.value || '',
        inheritData: {
          additionalProperties: [],
          customProperties: [],
          customConfigurations: [],
        },
      });
    });

    const result = await Promise.all(promises);

    let covers: string[] = [];
    if (
      resourceCreatorBatchPage.selectedResourceType?.labels.includes('图片')
    ) {
      covers = await handleImage({
        sha1s: data_objs.map((f) => {
          return f.sha1;
        }),
      });
    }
    const data_isOccupied: {
      [sha1: string]: {
        userId: number;
        resourceId: string;
        resourceName: string;
        resourceType: string[];
        version: string;
        resourceVersions: {
          version: string;
        }[];
      }[];
    } = await occupies(
      data_objs.map((o) => {
        return o.sha1;
      }),
    );
    set$globalLoading(false);
    await refPromise.current;
    let dataSource: HandleStates['dataSource'] = [
      ...get$dataSource(),
      ...data_objs.map((obj, obj_index) => {
        const uid: string = String(Math.random());
        if (
          data_isOccupied[obj.sha1] &&
          data_isOccupied[obj.sha1].length > 0 &&
          data_isOccupied[obj.sha1][0].userId !==
            FUtil.Tool.getUserIDByCookies()
        ) {
          const errorInfo: NonNullable<HandleStates['dataSource'][number]> = {
            uid: uid,
            state: 'error',
            errorInfo: {
              uid: uid,
              sha1: obj.sha1,
              name: obj.objectName,
              from: '存储空间',
              errorText: FI18n.i18nNext.t(
                'submitresource_err_resourceexist_otheruser',
              ),
              otherUsedResourcesAndVersions: data_isOccupied[obj.sha1]
                .map((d) => {
                  return d.resourceVersions.map((v: any) => {
                    return {
                      resourceID: d.resourceId,
                      resourceName: d.resourceName,
                      resourceType: d.resourceType,
                      resourceVersion: v.version,
                      url: FUtil.LinkTo.resourceDetails({
                        resourceID: d.resourceId,
                        version: v.version,
                      }),
                    };
                  });
                })
                .flat(),
            },
            listInfo: null,
            localUploadInfo: null,
          };
          return errorInfo;
        }
        if (
          data_isOccupied[obj.sha1] &&
          data_isOccupied[obj.sha1].length > 0 &&
          data_isOccupied[obj.sha1][0].userId ===
            FUtil.Tool.getUserIDByCookies()
        ) {
          const errorInfo: NonNullable<HandleStates['dataSource'][number]> = {
            uid: uid,
            state: 'error',
            errorInfo: {
              uid: uid,
              sha1: obj.sha1,
              name: obj.objectName,
              from: '存储空间',
              errorText: FI18n.i18nNext.t(
                'submitresource_err_resourceexist_sameuser',
              ),
              selfUsedResourcesAndVersions: data_isOccupied[obj.sha1]
                .map((d) => {
                  return d.resourceVersions.map((v: any) => {
                    return {
                      resourceID: d.resourceId,
                      resourceName: d.resourceName,
                      resourceType: d.resourceType,
                      resourceVersion: v.version,
                      url: FUtil.LinkTo.resourceDetails({
                        resourceID: d.resourceId,
                        version: v.version,
                      }),
                    };
                  });
                })
                .flat(),
            },
            listInfo: null,
            localUploadInfo: null,
          };
          return errorInfo;
        }

        const resourceName: string = getARightName(
          FRegExpMgr.removeExtension(obj.objectName),
        ).substring(0, 50);

        const resourceTitle: string = obj.objectName
          .replace(new RegExp(/\.[\w-]+$/), '')
          .substring(0, 100);
        const successFile = result.find((file) => {
          return obj.sha1 === file.sha1;
        });

        const listInfo: NonNullable<HandleStates['dataSource'][number]> = {
          uid: uid,
          state: 'list',
          listInfo: {
            uid: uid,
            fileName: obj.objectName,
            sha1: obj.sha1,
            cover: covers[obj_index] || '',
            resourceName: resourceName,
            resourceName_optimized: resourceName,
            resourceNameError: '',
            resourceTitle: resourceTitle,
            resourceTitleError: '',
            resourceLabels: [],
            resourcePolicies: [],
            showMore: false,
            systemProperties: successFile?.systemProperties || [],
            customProperties: successFile?.customProperties || [],
            customConfigurations: successFile?.customConfigurations || [],
            directDependencies: [],
            baseUpcastResources: [],
            resolveResources: [],
            isCompleteAuthorization: true,
            batchSignContracts: [],
          },
          localUploadInfo: null,
          errorInfo: null,
        };
        return listInfo;
      }),
    ];
    if (dataSource.length > 20) {
      // fMessage('上传不能超过20个文件', 'warning');
      fMessage(
        FI18n.i18nNext.t('brr_submitresource_alert_limitation'),
        'warning',
      );
      dataSource = dataSource.slice(0, 20);
    }
    // console.log(dataSource, 'dataSource 9843iohsdlk;fjsdlkfjlsdjl');
    const {
      data: data_ResourceNames,
    }: {
      data: {
        newResourceName: string;
      }[];
    } = await FServiceAPI.Resource.generateResourceNames({
      resourceNames: dataSource
        .filter((resource) => {
          return !(
            resource.state !== 'list' ||
            !resource.listInfo ||
            resource.listInfo.resourceName === ''
          );
        })
        .map((resource) => {
          return resource.listInfo?.resourceName || '';
        }),
    });

    const newResourceNames: string[] = data_ResourceNames.map((rn) => {
      return rn.newResourceName;
    });
    // console.log(JSON.stringify(newResourceNames), 'newResourceNamessldkfjlskdjl');
    set$dataSource(
      dataSource.map((resource) => {
        if (
          resource.state !== 'list' ||
          !resource.listInfo ||
          resource.listInfo.resourceName === ''
        ) {
          return resource;
        }
        const resourceName: string = newResourceNames.shift() || '';
        return {
          ...resource,
          listInfo: {
            ...resource.listInfo,
            resourceName,
            resourceName_optimized: resourceName,
          },
        };
      }),
    );
  }

  async function onClickRelease() {
    const qty: number = get$dataSource().filter((d) => {
      return d.listInfo?.resourcePolicies.length === 0;
    }).length;
    if (qty > 0) {
      const confirm: boolean = await fPromiseModalConfirm({
        title: '提示',
        // description: '下架后，其它用户将无法签约该展品，确认要下架吗？',
        description: FI18n.i18nNext.t(
          'brr_resourcelisting_complete_confirm_msg',
          {
            qty: qty,
          },
        ),
        okText: FI18n.i18nNext.t('brr_resourcelisting_complete_confirm_btn'),
        cancelText: FI18n.i18nNext.t('btn_cancel'),
        // promptKey_localStorage: 'offlineExhibit',
      });
      if (!confirm) {
        return;
      }
    }

    const createResourceObjects: {
      name: string;
      resourceTitle?: string;
      policies?: {
        policyName: string;
        policyText: string;
        status?: 1 | 0;
      }[];
      coverImages?: string[];
      intro?: string;
      tags?: string[];

      version: string;
      fileSha1: string;
      filename: string;
      description?: string;
      dependencies?: {
        resourceId: string;
        versionRange: string;
      }[];
      customPropertyDescriptors?: {
        key: string;
        name: string;
        defaultValue: string;
        type: 'editableText' | 'readonlyText' | 'radio' | 'checkbox' | 'select';
        candidateItems?: string[];
        remark?: string;
      }[];
      baseUpcastResources?: {
        resourceId: string;
      }[];
      resolveResources: {
        resourceId: string;
        contracts: {
          policyId: string;
        }[];
      }[];
      inputAttrs?: {
        key: string;
        value: string;
      }[];
    }[] = [];

    for (const data of get$dataSource()) {
      if (data.state === 'list' && data.listInfo) {
        const item = data.listInfo;

        const batchSignContracts: {
          resourceId: string;
          // resourceName: string;
          policyIds: string[];
          // subjectType: 'resource' | '';
          subjectType: string;
        }[] = (item.batchSignContracts || []).map((b) => {
          return {
            resourceId: b.resourceID,
            // resourceName: b.resourceName,
            policyIds: b.policyIDs,
            subjectType: b.subjectType,
          };
        });
        createResourceObjects.push({
          // name: item.resourceName,
          name: item.resourceName_optimized,
          resourceTitle: item.resourceTitle,
          policies: item.resourcePolicies.map((p) => {
            return {
              policyName: p.title,
              policyText: p.text,
              status: 1,
            };
          }),
          coverImages: item.cover === '' ? [] : [item.cover],
          intro: '',
          tags: item.resourceLabels,
          version: '1.0.0',
          fileSha1: item.sha1,
          filename: item.fileName,
          description: '',
          customPropertyDescriptors: [
            ...item.customProperties.map<
              NonNullable<
                Parameters<
                  typeof FServiceAPI.Resource.createVersion
                >[0]['customPropertyDescriptors']
              >[number]
            >((i) => {
              return {
                type: 'readonlyText',
                key: i.key,
                name: i.name,
                remark: i.description,
                defaultValue: i.value,
              };
            }),
            ...item.customConfigurations.map<
              NonNullable<
                Parameters<
                  typeof FServiceAPI.Resource.createVersion
                >[0]['customPropertyDescriptors']
              >[number]
            >((i) => {
              const isInput: boolean = i.type === 'input';
              const options: string[] = i.select;
              return {
                type: isInput ? 'editableText' : 'select',
                key: i.key,
                name: i.name,
                remark: i.description,
                defaultValue: isInput ? i.input : options[0],
                // defaultValue: isInput ? i.input : '',
                candidateItems: isInput ? undefined : options,
              };
            }),
          ],
          baseUpcastResources: item.baseUpcastResources.map((r) => {
            return { resourceId: r.resourceID };
          }),
          dependencies: item.directDependencies.map((r) => {
            return {
              resourceId: r.id,
              versionRange: r.versionRange || '',
            };
          }),
          // @ts-ignore
          batchSignContracts: batchSignContracts,
          // resolveResources: item.resolveResources,
          inputAttrs: item.systemProperties
            .filter((sp) => sp.type === 'additional')
            .map((ap) => {
              return {
                key: ap.key,
                value: ap.value,
              };
            }),
        });
      }
    }

    set$committing(true);
    const params: Parameters<typeof FServiceAPI.Resource.createBatch>[0] = {
      resourceTypeCode:
        resourceCreatorBatchPage.selectedResourceType?.value || '',
      createResourceObjects: createResourceObjects,
    };
    const {
      data,
    }: {
      data: {
        [resourceID: string]: {
          data: {
            resourceId: string;
            resourceName: string;
            resourceTitle: string;
            coverImages: string[];
            status: number;
            policies: any[];
          } | null;
          message: string;
          status: number;
        };
      };
    } = await FServiceAPI.Resource.createBatch(params);

    // console.log(data, 'data isdjflksjdlkfjslkdjflkjsolikfjewsoijlkj');

    const list: {
      resourceID: string;
      resourceName: string;
      resourceTitle: string;
      cover: string;
      status: 'online' | 'offline' | 'unreleased' | 'freeze';
      policies: string[];
      failReason: string;
    }[] = Object.entries(data)
      // .filter((d) => {
      //   return !d.data;
      // })
      .map(([k, d]) => {
        // const data = d.data;
        if (!d.data) {
          // console.log(createResourceObjects, 'createResourceObjectssdfjlsdkjflksdjklfjdslkjflkdsjlkj');
          const oldResource = createResourceObjects.find((ro) => {
            return ro.name === k;
          });
          return {
            resourceID: FUtil.Tool.generateRandomCode(),
            resourceName: oldResource?.name || '资源创建失败',
            resourceTitle: oldResource?.resourceTitle || '资源创建失败',
            cover: '',
            status: 'unreleased',
            policies: [],
            failReason: d.message,
          };
        }
        return {
          resourceID: d.data.resourceId,
          resourceName: d.data.resourceName,
          resourceTitle: d.data.resourceTitle,
          cover: d.data.coverImages[0] || '',
          status:
            d.data.status === 2
              ? 'freeze'
              : d.data.status === 1
              ? 'online'
              : d.data.status === 0
              ? 'unreleased'
              : 'offline',
          policies: d.data.policies.map((p: any) => {
            return p.policyName;
          }),
          failReason: d.message || '',
        };
      });
    // console.log(list, 'sdiofj;sldkjflksdjfolijsdolfjlksdjlkj');
    dispatch<ChangeAction>({
      type: 'resourceCreatorBatchPage/change',
      payload: {
        showPage: 'finish',
        resultList: list,
      },
    });
  }

  return (
    <>
      {$dataSource.length === 0 && (
        <UploadFile
          onLocalUpload={onLocalUpload}
          onImportStorage={onImportStorage}
        />
      )}

      {$dataSource.length > 0 && (
        <>
          <FPrompt
            watch={$dataSource.length > 0}
            onOk={(locationHref) => {
              history.push(locationHref);
            }}
          />

          <div className={styles.container3}>
            <div style={{ width: 920 }}>
              <div style={{ height: 35 }} />
              <div className={styles.nav}>
                <div className={styles.left}>
                  {FI18n.i18nNext.t('brr_title_bulkreleaseresource')}
                </div>
                <div style={{ width: 10 }} />
                <div className={styles.other}>{'>'}</div>
                <div style={{ width: 7 }} />
                <div className={styles.other}>
                  {FI18n.i18nNext.t('brr_resourcelisting_title')}
                </div>
              </div>
              <div style={{ height: 35 }} />
              <div className={styles.header}>
                <Space size={10}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t(
                      'brr_resourcelisting_label_resourcetype',
                    )}
                    type={'additional2'}
                  />
                  <FComponentsLib.FContentText
                    text={resourceCreatorBatchPage.selectedResourceType?.labels.join(
                      '/',
                    )}
                    type={'highlight'}
                    style={{ fontSize: 12 }}
                  />
                </Space>

                <FComponentsLib.FContentText
                  // text={`共 ${resourceCreatorBatchPage.resourceListInfo.length} 个资源`}
                  text={FI18n.i18nNext.t(
                    'brr_resourcelisting_label_resourceqty',
                    {
                      ResourceQty: $dataSource.length,
                    },
                  )}
                  type={'additional2'}
                />
              </div>
              {$dataSource.map((r, ri) => {
                return (
                  <React.Fragment key={r.uid}>
                    <div style={{ height: 40 }} />
                    {r.state === 'localUpload' && r.localUploadInfo && (
                      <Task
                        order={ri + 1}
                        file={r.localUploadInfo.file}
                        resourceTypeCode={
                          resourceCreatorBatchPage.selectedResourceType
                            ?.value || ''
                        }
                        resourceType={
                          resourceCreatorBatchPage.selectedResourceType
                            ?.labels || []
                        }
                        onSuccess={(value) => {
                          set$tempLocalSuccess([
                            ...get$tempLocalSuccess(),
                            value,
                          ]);
                        }}
                        onFail={(value) => {
                          set$dataSource(
                            get$dataSource().map((d) => {
                              if (d.uid !== value.uid) {
                                return d;
                              }
                              return {
                                uid: value.uid,
                                state: 'error',
                                errorInfo: {
                                  uid: value.uid,
                                  sha1: value.sha1,
                                  name: value.name,
                                  from: '本地上传',
                                  errorText: value.errorText,
                                  otherUsedResourcesAndVersions:
                                    value.otherUsedResourcesAndVersions,
                                  selfUsedResourcesAndVersions:
                                    value.selfUsedResourcesAndVersions,
                                },
                                listInfo: null,
                                localUploadInfo: null,
                              };
                            }),
                          );
                        }}
                        onCancel={(value) => {
                          set$dataSource(
                            get$dataSource().filter((d) => {
                              return d.uid !== value.uid;
                            }),
                          );
                        }}
                      />
                    )}
                    {r.state === 'list' && !!r.listInfo && (
                      <Card
                        resourceType={
                          resourceCreatorBatchPage.selectedResourceType
                            ?.labels || []
                        }
                        resourceTypeCode={
                          resourceCreatorBatchPage.selectedResourceType?.value
                        }
                        order={ri + 1}
                        username={$username}
                        info={r.listInfo}
                        onChange={(value) => {
                          let dataSource: HandleStates['dataSource'] =
                            get$dataSource().map((d) => {
                              if (d.uid !== r.uid) {
                                return d;
                              }
                              return {
                                ...d,
                                listInfo: value,
                              };
                            });
                          set$dataSource(dataSource);
                          run();
                        }}
                        onDelete={() => {
                          const dataSource: HandleStates['dataSource'] =
                            get$dataSource().filter((rli) => {
                              return rli.uid !== r.uid;
                            });
                          set$dataSource(dataSource);
                          run();
                        }}
                        onClickApplyPolicies={
                          $dataSource.filter((ds) => {
                            return ds.state === 'list' && ds.listInfo;
                          }).length <= 1 ||
                          r.listInfo.resourcePolicies.length === 0
                            ? undefined
                            : async () => {
                                let confirm: boolean =
                                  await fPromiseModalConfirm({
                                    title: '添加策略到其它资源',
                                    description:
                                      FI18n.i18nNext.t(
                                        '是否将策略应用于此处发行的所有资源？',
                                      ),
                                    cancelText: FI18n.i18nNext.t(
                                      'brr_resourcelisting_confirmation_bulkaddtags_btn_no',
                                    ),
                                    okText: FI18n.i18nNext.t(
                                      'brr_resourcelisting_confirmation_bulkaddtags_btn_yes',
                                    ),
                                  });

                                if (!confirm) {
                                  return;
                                }

                                const dataSource: HandleStates['dataSource'] =
                                  get$dataSource().map((rli) => {
                                    if (
                                      r.uid === rli.uid ||
                                      !rli.listInfo ||
                                      !r.listInfo
                                    ) {
                                      return rli;
                                    }
                                    const usedText: string[] =
                                      rli.listInfo.resourcePolicies.map((p) => {
                                        return p.text;
                                      });
                                    const usedTile: string[] =
                                      rli.listInfo.resourcePolicies.map((p) => {
                                        return p.title;
                                      });
                                    const policies: {
                                      title: string;
                                      text: string;
                                    }[] = r.listInfo.resourcePolicies.filter(
                                      (p) => {
                                        return (
                                          !usedText.includes(p.text) &&
                                          !usedTile.includes(p.title)
                                        );
                                      },
                                    );
                                    return {
                                      ...rli,
                                      listInfo: {
                                        ...rli.listInfo,
                                        resourcePolicies: [
                                          ...rli.listInfo.resourcePolicies,
                                          ...policies,
                                        ],
                                      },
                                    };
                                  });

                                set$dataSource(dataSource);
                              }
                        }
                        onClickApplyLabels={
                          $dataSource.filter((ds) => {
                            return ds.state === 'list' && ds.listInfo;
                          }).length <= 1 ||
                          r.listInfo.resourceLabels.length === 0
                            ? undefined
                            : async () => {
                                let confirm: boolean =
                                  await fPromiseModalConfirm({
                                    title: FI18n.i18nNext.t(
                                      'brr_resourcelisting_confirmation_bulkaddtags_title',
                                    ),
                                    description:
                                      FI18n.i18nNext.t(
                                        '是否将标签应用于此处发行的所有资源？',
                                      ),
                                    cancelText: FI18n.i18nNext.t(
                                      'brr_resourcelisting_confirmation_bulkaddtags_btn_no',
                                    ),
                                    okText: FI18n.i18nNext.t(
                                      'brr_resourcelisting_confirmation_bulkaddtags_btn_yes',
                                    ),
                                  });

                                if (!confirm) {
                                  return;
                                }

                                const dataSource: HandleStates['dataSource'] =
                                  get$dataSource().map((rli) => {
                                    if (
                                      r.uid === rli.uid ||
                                      !rli.listInfo ||
                                      !r.listInfo
                                    ) {
                                      return rli;
                                    }
                                    const resourceLabels: string[] = Array.from(
                                      new Set([
                                        ...rli.listInfo.resourceLabels,
                                        ...r.listInfo.resourceLabels,
                                      ]),
                                    ).slice(0, 20);
                                    return {
                                      ...rli,
                                      listInfo: {
                                        ...rli.listInfo,
                                        resourceLabels: resourceLabels,
                                      },
                                    };
                                  });
                                set$dataSource(dataSource);
                              }
                        }
                      />
                    )}

                    {r.state === 'error' && !!r.errorInfo && (
                      <ErrorCard
                        order={ri + 1}
                        errorInfo={r.errorInfo}
                        onDelete={() => {
                          const dataSource: HandleStates['dataSource'] =
                            get$dataSource().filter((rli) => {
                              return rli.uid !== r.uid;
                            });
                          set$dataSource(dataSource);
                        }}
                        onCorrect={(value) => {
                          set$tempLocalSuccess([
                            ...get$tempLocalSuccess(),
                            {
                              uid: value.uid,
                              name: value.name,
                              sha1: value.sha1,
                            },
                          ]);
                          handleLocalUploadSuccess();
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}
              <div style={{ height: 100 }} />
            </div>
          </div>

          <div className={styles.submit}>
            <div>
              <div>
                <FIcons.FInfo style={{ fontSize: 12 }} />
                &nbsp;
                {FI18n.i18nNext.t(
                  'brr_resourcelisting_toggles_availabletoauth',
                )}
              </div>
              <Space size={20}>
                {$dataSource.length < 20 && (
                  <FPopover
                    // open={true}
                    title={null}
                    overlayInnerStyle={{ padding: 0 }}
                    overlayStyle={{ padding: 0 }}
                    style={{ padding: 0 }}
                    content={
                      <div className={styles.continue}>
                        <div
                          onClick={() => {
                            onLocalUpload();
                          }}
                        >
                          <FIcons.FLocalUpload />
                          <div>
                            {FI18n.i18nNext.t(
                              'brr_submitresource_btn_uploadfromlocal',
                            )}
                          </div>
                        </div>
                        <div
                          onClick={() => {
                            onImportStorage();
                          }}
                        >
                          <FIcons.FStorageSpace />
                          <div>
                            {FI18n.i18nNext.t(
                              'brr_submitresource_btn_importfromstorage',
                            )}
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div>
                      <FComponentsLib.FRectBtn>
                        {FI18n.i18nNext.t(
                          'brr_resourcelisting_btn_moretoupload',
                        )}
                      </FComponentsLib.FRectBtn>
                    </div>
                  </FPopover>
                )}
                <FHotspotTooltip
                  id={'batchResourceCreator.perfectInformation.submitButton'}
                  style={{ left: 32, top: -38 }}
                  zIndex={100}
                  text={FI18n.i18nNext.t('hotpots_brr_info_done')}
                  onOpenChange={(o) => {
                    if (o) {
                      fSetHotspotTooltipVisible(
                        'batchResourceCreator.perfectInformation.submitButton',
                        {
                          value: false,
                          effectiveImmediately: false,
                          onlyNullish: false,
                        },
                      );
                    }
                  }}
                >
                  <FComponentsLib.FRectBtn
                    disabled={$submitDisable}
                    onClick={() => {
                      onClickRelease();
                    }}
                  >
                    {FI18n.i18nNext.t(
                      'brr_resourcelisting_btn_completerelease',
                    )}
                  </FComponentsLib.FRectBtn>
                </FHotspotTooltip>
              </Space>
            </div>
          </div>
        </>
      )}

      <FGlobalLoading
        open={$globalLoading}
        onOpened={(promise) => {
          refPromise.current = promise;
        }}
        onClosed={() => {}}
      />
    </>
  );
}

export default connect(({ resourceCreatorBatchPage }: ConnectState) => ({
  resourceCreatorBatchPage: resourceCreatorBatchPage,
}))(Handle);

function getARightName(name: string) {
  return FRegExpMgr.resourceNameOptimized(name);
}

async function occupies(sha1s: string[]): Promise<{
  [sha1: string]: {
    userId: number;
    resourceId: string;
    resourceName: string;
    resourceType: string[];
    version: string;
    resourceVersions: {
      version: string;
    }[];
  }[];
}> {
  // console.log(sha1s, 'sha1s sdifjlsdkjflkjsha1s sha1s sdfijsd;lkfjlksdjflkjlkj');
  const result: {
    [sha1: string]: {
      userId: number;
      resourceId: string;
      resourceName: string;
      resourceType: string[];
      version: string;
      resourceVersions: {
        version: string;
      }[];
    }[];
  } = {};
  for (const sha1 of sha1s) {
    const params3: Parameters<
      typeof FServiceAPI.Resource.getResourceBySha1
    >[0] = {
      fileSha1: sha1,
    };

    const {
      data: data_ResourcesBySha1,
    }: {
      data: {
        userId: number;
        resourceId: string;
        resourceName: string;
        resourceType: string[];
        version: string;
        resourceVersions: {
          version: string;
        }[];
      }[];
    } = await FServiceAPI.Resource.getResourceBySha1(params3);

    if (data_ResourcesBySha1.length > 0) {
      result[sha1] = data_ResourcesBySha1;
    }
  }
  return result;
}

interface HandleImageParams {
  sha1s: string[];
}

async function handleImage({ sha1s }: HandleImageParams): Promise<string[]> {
  const URLs: string[] = [];

  let index: number = 0;
  while (index < sha1s.length) {
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = await FServiceAPI.Storage.generateCoverImage({
      sha1: sha1s[index],
    });

    if (ret !== 0 || errCode !== 0) {
      URLs.push('');
      index++;
    } else if (!!data && data.url) {
      URLs.push(data.url);
      index++;
    }
    await FUtil.Tool.promiseSleep(200);
  }
  return URLs;
}
